import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import { Button } from "semantic-ui-react";
import SelectableList from "../components/SelectableList";
import { useCustomQuery } from "utilities/hookutils";
import { getSortedBookkeepings, initialBookkeepingFilter } from "./FilterTypes/BookkeepingFilterType";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";

interface Props {
  initialBookkeepings?: server.dto.BookkeepingSmall[]
}

const BookkeepingFilter = (props: Props) => {
  const title = RESX.Bookkeeping.resxBookkeeping;
  const initialValue = {
    ...initialBookkeepingFilter,
    initialBookkeepings: props.initialBookkeepings ?? []
  };

  const api = useCustomQuery({
    queryFn: async () => window.CoreApi.Bookkeeping.GetBookkeepings(),
    queryKey: ["bookkeepings"],
    enabled: false
  });

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("bookkeepings", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedBookkeepings(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedBookkeepings.length > 0,
    reset: () => initialValue,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedBookkeepings.map(b => b.bookkeepingId), b.selectedBookkeepings.map(b => b.bookkeepingId))
  });
  useEffect(() => {
    setInitialValue("bookkeepings", initialValue);
  }, []);

  const [selectedBookkeepings, setSelectedBookkeepings] = React.useState<server.dto.BookkeepingSmall[]>(initialValue.selectedBookkeepings);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    if (getValue("bookkeepings").initialBookkeepings.length === 0) { api.refetch(); }

    setSelectedBookkeepings(getValue("bookkeepings").selectedBookkeepings);
    setPopupOpen(true);
  };

  const onBookkeepingToggled = (bookkeeping: server.dto.BookkeepingSmall) => {
    const bookkeepingExists = selectedBookkeepings.some(b => b.bookkeepingId === bookkeeping.bookkeepingId);
    if (bookkeepingExists) {
      const newBookkeepings = selectedBookkeepings.filter(b => b.bookkeepingId !== bookkeeping.bookkeepingId);
      setSelectedBookkeepings(newBookkeepings);
    } else {
      const newBookkeepings = [...selectedBookkeepings, bookkeeping];
      setSelectedBookkeepings(newBookkeepings);
    }
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("bookkeepings", {
      selectedBookkeepings,
      initialBookkeepings: getValue("bookkeepings").initialBookkeepings
    });
    setPopupOpen(false);
  };

  const bookkeepings = api.data?.data ?? getValue("bookkeepings").initialBookkeepings ?? [];

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      isLoading={getValue("bookkeepings").initialBookkeepings == null ? api.isLoading : false}
      content={<form onSubmit={onApply} onKeyDown={(e) => { if (e.key === "Enter") onApply(e); }}>
        <div className="margin-bottom">
          <SelectableList
            selectedItems={selectedBookkeepings}
            items={bookkeepings}
            onItemToggled={onBookkeepingToggled}
            noScrolling={bookkeepings.length <= 6}
            getId={b => b.bookkeepingId}
            getName={b => b.name}
            getSubLabel={b => b.code}
          />
        </div>

        <Button fluid type="submit" primary>
          {RESX.SelectionManager.Apply}
        </Button>
      </form>}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default BookkeepingFilter;
